import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'

import colors from '@/mixins/Colors'

import store from '@/store/store'
import router from './routes/router'

import VueBarcodeScanner from 'vue-barcode-scanner'

import axios from 'axios'
import { Model } from 'vue-api-query'

import SnackbarModalUtils from '@/mixins/SnackbarModalUtils'
import { beforeRequest, errorRequest } from '@/services/InterceptorAxios'
import { addDefaultCashDeskToken_WhenByPassLogin } from '@/services/MockCashDeskTokenService'
axios.defaults.headers.common['Content-Type'] = 'application/json'
const token = localStorage.getItem('user-token')
if (token) {
    axios.defaults.headers.common['Authorization'] = token
}

// Add a request and response interceptor
axios.interceptors.request.use(beforeRequest, undefined)
axios.interceptors.response.use(undefined, errorRequest)

import { permissions } from './mixins/reusable_mixins'
Vue.mixin(permissions)

import AuthCodePermissions from './mixins/AuthCodePermissions'
Vue.mixin(AuthCodePermissions)

// Linked axios with app models
Model.$http = axios

// Add Default CAshDeskToken if needed
addDefaultCashDeskToken_WhenByPassLogin()

Vue.use(VueBarcodeScanner)
Vue.mixin(SnackbarModalUtils)
Vue.config.productionTip = false
Vue.mixin({
    data: function() {
        return {
            colors: colors,
        }
    },
})
new Vue({
    store,
    router,
    render: h => h(App),
}).$mount('#app')
